module.exports = __webpack_public_path__ + "static/img/7.92321b4c.jpg";